import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LandingService } from "../../services/Landing_Services/landing.service";
import { PricingPlan } from "../../utilities/interfaces/CMS_Interfaces/pricing_plan_interfaces/pricing-plan.interface";

@Component({
  selector: "app-pricing",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./pricing.component.html",
  styleUrl: "./pricing.component.css",
})
export class PricingComponent implements OnInit {
  plans: PricingPlan[] | null = null;

  constructor(private landingService: LandingService) {}

  ngOnInit(): void {
    this.landingService.getPricingPlans().subscribe((data) => {
      if (data && Array.isArray(data)) {
        // Filter by active status and sort by weight
        this.plans = data
          .filter((plan) => plan.status === "Active")
          .sort((a, b) => (a.weight || 0) - (b.weight || 0))
          .map((plan) => {
            // Sort items by weight and filter active items
            if (plan.items && Array.isArray(plan.items)) {
              plan.items = plan.items
                .filter((item) => item.status === "Active")
                .sort((a, b) => (a.weight || 0) - (b.weight || 0));
            } else {
              plan.items = [];
            }
            return plan;
          });
        setTimeout(() => this.initScrollAnimations(), 0);
      }
    });
  }

  private initScrollAnimations() {
    if (typeof document === "undefined") return;
    setTimeout(() => {
      const reveals = document.querySelectorAll(".pricing-grid .reveal");
      if (!reveals.length) return;

      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("active");
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px",
        },
      );

      reveals.forEach((reveal) => {
        revealObserver.observe(reveal);
      });
    }, 100);
  }
}
